export default __webpack_public_path__ + "static/media/silver_outlined.d2d06caf.svg";